export default "__VITE_ASSET__50e15900__"